import { useMutation } from '@tanstack/react-query';

import {
  BulkUpdateUnusedVoucherUsersExpiryPayload,
  BulkUpdateUnusedVoucherUsersExpiryResponse,
  bulkUpdateUnusedVoucherUsersExpiry,
} from '~/services/PromoService';

export function useBulkUpdateUnusedVoucherUsersExpiry() {
  return useMutation<BulkUpdateUnusedVoucherUsersExpiryResponse, Error, BulkUpdateUnusedVoucherUsersExpiryPayload>({
    mutationFn: async (payload) => bulkUpdateUnusedVoucherUsersExpiry(payload),
  });
}
